import { responsiveVanillaSelector } from '../selectors';
import type { Site } from '../Site';

export const BikePerfect: Site = {
  id: 'bikeperfect',
  logo: 'svg/bikeperfect.svg',
  label: 'Bike Perfect',
  analyticsName: 'bikeperfect',
  hostname: 'bikeperfect.com',
  platform: 'responsive',
  selector: responsiveVanillaSelector,
};
